<template>
  <ol class="rk">
    <li v-for="(c, i) in items" :key="c.idCuenta" class="rk-row">
      <span class="rk-pos">{{ i + 1 }}</span>
      <span class="rk-dot" :style="{ background: c.color }"></span>
      <span class="rk-name" :title="c.cliente">{{ c.cliente }}</span>
      <!-- Solo las cuentas con más de una evaluación tienen variación. -->
      <span
        v-if="c.delta != null"
        class="rk-delta"
        :class="c.delta >= 0 ? 'up' : 'down'"
      >
        {{ c.delta >= 0 ? "▲" : "▼" }} {{ Math.abs(c.delta).toFixed(1) }}
      </span>
      <span v-else class="rk-delta rk-na" title="Sin evaluación previa">—</span>
      <span class="rk-score">{{ c.score.toFixed(1) }}%</span>
    </li>
    <li v-if="!items.length" class="rk-empty">Sin cuentas evaluadas.</li>
  </ol>
</template>

<script>
export default {
  name: "RankingList",
  props: {
    // [{ idCuenta, cliente, score, color, delta }]
    items: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.rk {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.rk-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 4px;
  font-size: 13px;
  border-bottom: 1px solid var(--border);
}
.rk-row:last-child {
  border-bottom: none;
}

.rk-pos {
  width: 18px;
  color: var(--txt-faint);
  font-size: 11px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.rk-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.rk-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.rk-delta {
  font-size: 11px;
  font-weight: 700;
  width: 54px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.rk-delta.up {
  color: var(--verde);
}
.rk-delta.down {
  color: var(--rojo);
}
.rk-delta.rk-na {
  color: var(--txt-faint);
}

.rk-score {
  width: 56px;
  text-align: right;
  font-weight: 800;
  color: var(--heading);
  font-variant-numeric: tabular-nums;
}

.rk-empty {
  padding: 14px 4px;
  color: var(--txt-dim);
  font-size: 13px;
}
</style>
